// Dusseldorf compliance requirement
const companiesWithAcceptSettingHidden = [77294, 77386, 77295, 77292];

export const isAutoAcceptSettingVisible = (companyId: number) => !companiesWithAcceptSettingHidden.includes(companyId);
